import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import set from 'lodash/set';
import get from 'lodash/get';
import merge from 'lodash/merge';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';

const KEYS = ['xs', 'sm', 'md', 'lg', 'xl'];

const COLORS = [
  'initial',
  'inherit',
  'primary',
  'secondary',
  'textPrimary',
  'textSecondary',
  'error',
]; // default colors

const STYLES = [
  { size: 'fontSize', weight: 'fontWeight' },
  'display',
  'color',
  'justifyContent',
  'alignItems',
  'flexDirection',
  'lineHeight',
  'position',
  'width',
  'height',
  'maxWidth',
  'maxHeight',
  {
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginRight,marginLeft',
    my: 'marginTop,marginBottom',
  },
];

const STYLE_PROPS = Object.assign(
  {},
  ...STYLES.map((s) => (typeof s === 'string' ? { [s]: s } : s)),
);

const buildValue = (theme, name, value) => {
  if (isNumber(value) && name.match(/^(margin)/g)) {
    return theme.spacing(value);
  } else if (isNumber(value) && name === 'fontSize') {
    return theme.typography.pxToRem(value);
  } else if (isString(value) && value.includes('.')) {
    return get(theme, value, value);
  }
  return value;
};

const buildStyles = (theme, name, value) => {
  const styles = {};
  if (value) {
    if (isObject(value)) {
      KEYS.forEach(
        (key) =>
          key in value &&
          name
            .split(',')
            .forEach((n) =>
              set(
                styles,
                [theme.breakpoints.up(key), n],
                buildValue(theme, n, value[key]),
              ),
            ),
      );
    } else {
      name.split(',').forEach((n) => (styles[n] = buildValue(theme, n, value)));
    }
  }
  return styles;
};

const AppTypography = withStyles((theme) => ({
  root: (props) =>
    merge(
      {},
      ...Object.entries(props || {}).map(([key, value]) =>
        key in STYLE_PROPS ? buildStyles(theme, STYLE_PROPS[key], value) : {},
      ),
    ),
}))(
  React.forwardRef(({ children, color, ...props }, ref) => (
    <Typography
      {...(COLORS.includes(color) && { color })}
      {...merge(
        {},
        ...Object.entries(props)
          .filter(([name]) => !(name in STYLE_PROPS))
          .map(([name, value]) => ({ [name]: value })),
      )}
      ref={ref}
    >
      {children}
    </Typography>
  )),
);

AppTypography.propTypes = {
  ...Object.assign(
    {},
    ...Object.keys(STYLE_PROPS).map((s) => ({ [s]: PropTypes.any })),
  ),
};

export default AppTypography;
